import { render, staticRenderFns } from "./aiWarnNum.vue?vue&type=template&id=321944b4&"
import script from "./aiWarnNum.vue?vue&type=script&lang=js&"
export * from "./aiWarnNum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports